import {
    ROUTE_PATH_THIRD_PARTY_REPORT_LIST,
    ROUTE_PATH_THIRDPARTY_HOME,
    ROUTE_PATH_THIRD_PARTY_REPLACE_CONTACT_PERSON,
    ROUTE_PATH_THIRD_PARTY_BASIC_INFOS,
    ROUTE_PATH_THIRD_PARTY_PRODUCTS_LIST,
    ROUTE_PATH_THIRD_PARTY_DOCUMENTS,
    ROUTE_PATH_THIRD_PARTY_COMMUNICATION
} from "src/modules/3rd-party-management/constants";

const ThirdPartyMenuItems = [
    {
        titleKey    :   "Home",
        linkType    :   "react-router",
        path        :   ROUTE_PATH_THIRDPARTY_HOME,
        icon        :   "ri-home-4-line",
        authProtected   :   false,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "My reports",
        linkType    :   "react-router",
        path        :   ROUTE_PATH_THIRD_PARTY_REPORT_LIST,
        icon        :   "ri-mail-line",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "Basic Information",
        linkType    :   "react-router",
        path        :   ROUTE_PATH_THIRD_PARTY_BASIC_INFOS,
        icon        :   "ri-file-text-line",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "Products",
        linkType    :   "react-router",
        path        :   ROUTE_PATH_THIRD_PARTY_PRODUCTS_LIST,
        icon        :   "ri-archive-drawer-line",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "Documents",
        linkType    :   "react-router",
        path        :   ROUTE_PATH_THIRD_PARTY_DOCUMENTS,
        icon        :   "ri-file-list-3-line",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "Communication",
        linkType    :   "react-router",
        path        :   ROUTE_PATH_THIRD_PARTY_COMMUNICATION,
        icon        :   "ri-chat-1-line",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "Replace contact person",
        linkType    :   "react-router",
        path        :   ROUTE_PATH_THIRD_PARTY_REPLACE_CONTACT_PERSON,
        icon        :   "ri-user-add-line",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null
    }
];

export default ThirdPartyMenuItems;